<template>
  <div class="CR">
    <div class="top">
      <a href="#/ApprovalIndex">
        <img src="../assets/images/adidas.png" style="width: 160px; height: 37px; margin-top: 10px" />
      </a>
      <a href="#/CRSupplement" style="margin-top: 10px; margin-left: 30px; float: left">
        <img src="../assets/icon/back2.png" />
      </a>
    </div>
    <div class="content_title content_column clearfix">
      <div style="display: flex" class="label-column d-flex d-flex-first">
        <label class="label" style="flex:2">
          <span>Project Code</span>
        </label>
        <label class="label" style="flex:2">
          <span>POS Name</span>
        </label>
        <label class="label">
          <span>Category Name</span>
        </label>
        <label class="label">
          <span>Amount(w/o VAT)</span>
        </label>
        <label class="label">
          <span>VAT Rate</span>
        </label>
        <label class="label">
          <span>Amount(w/ VAT)</span>
        </label>
        <div class="addColumn"></div>
      </div>
      <template v-for="item in columnsList">
        <div class="d-flex d-flex-first" :key="item.Id">
          <div class="colums">
            <div>
              <!-- <div style="display: flex" class="label-column">
                <label class="label" style="flex:2">
                  <span>Project Code</span>
                </label>
                <label class="label" style="flex:2">
                  <span>POS Name</span>
                </label>
                <label class="label">
                  <span>Category Name</span>
                </label>
                <label class="label">
                  <span>Amount(w/o VAT)</span>
                </label>
                <label class="label">
                  <span>VAT Rate</span>
                </label>
                <label class="label">
                  <span>Amount(w/ VAT)</span>
                </label>
                <el-button type="mini" class="addColumn" @click="addColumn(item)">+</el-button>
              </div>-->

              <div
                v-for="(column, index) in item.columns"
                :key="index"
                :div_id="index"
                style="display: flex;"
                class="select-wrap"
              >
                <div class="input-filter" style="flex:2">
                  <span>{{ item.projectCode }}</span>
                </div>
                <div class="input-filter" style="flex:2">
                  <span>{{ item.posFullNameCN }}</span>
                </div>
                <el-select
                  v-model="column.categoryName"                  
                  placeholder="Please Choose"
                  class="input-filter"
                  @change="changeCategoryName($event,column,item.columns,index)"
                  >
                  <!-- clearable -->
                  <el-option
                    v-for="item in categoryNames"
                    :key="item.categoryName"
                    :label="item.categoryName"
                    :value="item.categoryName"
                  ></el-option>
                </el-select>
                <el-input
                  class="input-filter"
                  v-model="column.amountExcl"
                  placeholder="Please input"
                  maxlength="20"
                  @focus="inputFocus(column, 'amountExcl')"
                  @input="inputCost(column, 'amountExcl')"
                ></el-input>
                <div class="input-filter input-special-filter">
                  <span>{{translateValue(column.VATRate)}}</span>
                </div>
                <el-input class="input-filter" v-model="column.AmountIncl" placeholder disabled></el-input>
                <div></div>
                <el-button
                  v-if="!index"
                  style="width: 50px; height: 40px;font-size:18px;"
                  @click="addColumn(item)"
                >+</el-button>
                <el-button v-else style="width: 50px; height: 40px;" @click="delColumn(item)">X</el-button>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="d-flex d-flex-first last-flex">
        <div class="flex-item">
          <label class="label">Capex(w/o VAT)</label>
          <div class="value">{{ transferToDecimal(columnStage.capexExcl) }}</div>
        </div>
        <div class="flex-item">
          <label class="label">Opex(w/o VAT)</label>
          <div class="value">{{ transferToDecimal(columnStage.opexExcl) }}</div>
        </div>
        <div class="flex-item">
          <label class="label">Digital(w/o VAT)</label>
          <div class="value">{{ transferToDecimal(columnStage.digitalExcl) }}</div>
        </div>
        <div class="flex-item">
          <label class="label">Capex</label>
          <div class="value">{{ transferToDecimal(columnStage.capexIncl) }}</div>
        </div>
        <div class="flex-item">
          <label class="label">Opex</label>
          <div class="value">{{ transferToDecimal(columnStage.opexIncl) }}</div>
        </div>
        <div class="flex-item">
          <label class="label">Digital</label>
          <div class="value">{{ transferToDecimal(columnStage.digitalIncl) }}</div>
        </div>
      </div>
      <el-button class="button-search" @click="save">Save</el-button>
    </div>
  </div>
</template>-->

<script>
export default {
  data() {
    return {
      columnsList: [],
      categoryNames: [],
      suppleDetail: [],
      suppleCategory: [],
      maxSpiltAmount:0
    };
  },
  computed: {
    columnsListStage() {
      let columnsList = [];
      if (this.columnsList) {
        this.columnsList.forEach(c => {
          columnsList.push(...c.columns);
         // Object.assign(c,{categoryName: "",amountExcl: "",VATRate: "",AmountIncl: "",sub_XPEX: ""});
        });
      }
      return columnsList;
    },
    columnStage() {
      let tmp = {
        capexIncl: 0,
        capexExcl: 0,
        opexIncl: 0,
        opexExcl: 0,
        digitalIncl: 0,
        digitalExcl: 0,
        //hqcrIncl: 0,
      //  hqcrExcl: 0
      };
      this.columnsListStage.forEach(c => {
        if (c.sub_XPEX === "Opex") {
          if (c.AmountIncl) {
            tmp.opexIncl = tmp.opexIncl + Number(c.AmountIncl);
          }
          if (c.amountExcl) {
            tmp.opexExcl = tmp.opexExcl + Number(c.amountExcl);
          }
        } else if (c.sub_XPEX === "Digital") {
          if (c.AmountIncl) {
            tmp.digitalIncl = tmp.digitalIncl + Number(c.AmountIncl);
          }
          if (c.amountExcl) {
            tmp.digitalExcl = tmp.digitalExcl + Number(c.amountExcl);
          }
        } else if (c.sub_XPEX === "Capex") {
          if (c.AmountIncl) {
            tmp.capexIncl = tmp.capexIncl + Number(c.AmountIncl);
          }
          if (c.amountExcl) {
            tmp.capexExcl = tmp.capexExcl + Number(c.amountExcl);
          }
        }
      });
      return tmp;
    }
  },
  created() {    
    let applicationT = this.$route.params.id ? this.$route.params.id : sessionStorage.getItem("CRSupplementListIds"); 
    if(applicationT=="upload") 
      this.GetSuppleUploadDetail();
    else
      this.getGetSuppleDetail();
    
    this.getGetSuppleCategory();
  },
  methods: {
    addColumn(item) {
      // console.log(item);
      let oo = {
        categoryName: "",
        amountExcl: "",
        VATRate: "",
        AmountIncl: "",
        sub_XPEX: ""
      };
      item.columns.push(oo);
    },
    delColumn(item) {
      let oo = item.columns.find(p => p.categoryName == item.categoryName);
      let index = item.columns.indexOf(oo);
      item.columns.splice(index, 1);
    },
    Max(arr) {
      if (arr.length > 0) {
        var MaxNumber = arr[0];
        for (var i = 0; i < arr.length; i++) {
          if (MaxNumber < arr[i]) {
            MaxNumber = arr[i];
          }
        }
        return MaxNumber;
      } else {
        return 0;
      }
    },
    inputCost(i, k) {
      i[k] = i[k].replace(/[^\d\.]/g, "");
      let [sInt, sFloat] = i[k].split(".");
      if (sFloat > 5) {
        sFloat = sFloat.slice(0, 5);
        i[k] = `${sInt}.${sFloat}`;
      }
      if (!!i[k]) {
        if (i.VATRate) {
          i.AmountIncl = (i[k] * (1 + Number(i.VATRate))).toFixed(2);
        }
      } else {
        i.AmountIncl = 0;
      }
    },
    inputFocus(i, v) {
      if (!!v) {
        if (i[v] == "0") {
          i[v] = "";
        }
      } else {
        return;
      }
    },
    save() {
      if(this.columnStage.capexIncl>this.maxSpiltAmount)
      {
        this.$message({
          type: "error",
          message: "Capex总金额大于"+this.maxSpiltAmount+"，请拆分项目确保Capex总金额在"+this.maxSpiltAmount+"以内",
        });
        return;
      }

      // for(let i=0;i<this.columnsList.length;i++)
      // {
      //   if(this.columnsList[i].columns[0].amountExcl==undefined || null)
      //   {
      //     this.$message({
      //       type: "error",
      //       message: "Amount(w/o VAT)不能为空",            
      //     });
      //     return;        
      //   }
      // }
      // this.columnsList.forEach(element => {
      //   if(element.columns[0].amountExcl=="" ||undefined || null)
      //   {
      //     this.$message({
      //     type: "error",
      //     message: "Amount(w/o VAT)不能为空",            
      //     });
      //     return;        
      //   }
      //   return;
      // });
      
      this.loading = true;
      this.columnsList.forEach(element => {
        element.action=="New"?"New":"Upgrade";
      });
      this.$api
          .post(
            "/CR/SaveCRSupplement/",
            {
              param:{
                crSupplement:this.columnsList,
                amount: this.columnStage
              }
            },
            (res) => {}
          )
          .then((res) => {
            if (res.data.status) {
              this.$message({
                type: "success",
                message: "Submit Successful !",
              });
              this.loading = false;
              window.open("#/CRSupplement","_self");
              //window.open("http://scr.kbpsoft.com",'_blank');//uat
              window.open("https://scr.adscld.biz/pages/Index.html?type=draft",'_blank');//prod
            } else {
              this.$message({
                type: "error",
                message: res.data.message,
              });
              this.loading = false;
              return false;
            }
          });
    },
    getGetSuppleDetail() {
      let application = this.$route.params.id
        ? this.$route.params.id
        : sessionStorage.getItem("CRSupplementListIds");
      // console.log(application,'21')
      this.$api
        .get("CR/GetSuppleDetail", {
          application: application
        })
        .then(res => {
          if (res.data.status) {
            res.data.content.forEach(c => {
              c["columns"] = [
                {
                  categoryName: "",
                  amountExcl: "",
                  VATRate: "",
                  AmountIncl: "",
                  sub_XPEX: ""
                }
              ];
              //Object.assign(c,{categoryName: "",amountExcl: "",VATRate: "",AmountIncl: "",sub_XPEX: ""});
            });
          } else {
            this.$message({
              type: "error",
              message: res.data.message
            });
            return false;
          }
          this.columnsList = res.data.content;
        });
    },
    GetSuppleUploadDetail() {      
      this.$api
        .get("CR/GetSuppleUploadDetail", {})
        .then(res => {
          if (res.data.status) {
            res.data.content.map(c => {
              c['columns'] =[
                {
                  categoryName: c.categoryName,
                  amountExcl: c.amountExcl,
                  VATRate: c.vatRate,
                  AmountIncl: c.amountIncl,
                  sub_XPEX: c.sub_XPEX
                }
              ]                          
            });  
          } else {
            this.$message({
              type: "error",
              message: res.data.message
            });
            return false;
          }
          this.columnsList = res.data.content;
        });
    },
    getGetSuppleCategory() {
      this.$api.get("CR/GetSuppleCategory", {}).then(res => {
        if (res.data.status) {
          this.categoryNames = res.data.content;
        } else {
          this.$message({
            type: "error",
            message: res.data.message
          });
          return false;
        }
      });
    },
    getSplitAmountMax() {
      this.$api.get("CR/GetPLM_CR_SplitAmountMax", {type:"SupplemnetCR"}).then(res => {
        if (res.data.status) {
          this.maxSpiltAmount = res.data.content;
        } else {
          this.$message({
            type: "error",
            message: res.data.message
          });
          return false;
        }
      });
    },
    changeCategoryName(event, column, columnsList, index) {
      let _columnsList = columnsList.filter(c => {
        return c.categoryName === event;
      });
      // console.log(event, _columnsList);
      if (_columnsList.length > 1) {
        columnsList[index].categoryName = "";
        columnsList[index].amountExcl = "";
        columnsList[index].VATRate = "";
        columnsList[index].AmountIncl = "";
        columnsList[index].sub_XPEX = "";

        this.$message({
          type: "error",
          message: "Category Name 已存在，请重新选择"
        });
        return;
      }
      let tmp = this.categoryNames.find(c => {
        return c.categoryName === event;
      });
      column.sub_XPEX = tmp.sub_XPEX;
      column.VATRate = tmp.vatRate;
      if (column.VATRate) {
        column.AmountIncl = (
          (column.amountExcl) *
          (1 + Number(column.VATRate))
        ).toFixed(2);
      }
    },
    translateValue(value) {
      if (!!value) {
        return `${value * 100}%`;
      } else {
        return "";
      }
    },
    transferToDecimal(value) {
      if (typeof(value)=="number") {
        value = parseFloat(value) + "";
        let [sInt, sFloat] = value.toString().split(".");
        sInt = sInt.replace(/\d(?=(\d{3})+$)/g, "$&,");
        if (sFloat) {
          sFloat = sFloat.substr(0, 2);
        }
        // 区分整数与浮点小数
        return (value = sFloat ? `${sInt}.${sFloat}` : `${sInt}.00`);
      } else {
        return value;
      }
    }
  },
  mounted() {
    this.getSplitAmountMax();
  }
};
</script>

<style lang="scss" scoped>
.top {
  height: 60px;
  background: #232b33;
  color: white;
  text-align: center;
  line-height: 50px;
}
.d-flex {
  display: flex;
  align-items: center;
  text-align: left;
  margin: auto;
  width: 94%;
  flex-wrap: wrap;
  border: 1px solid #e6a23c;
  border-bottom: none;
  border-left: none;
  &.last-flex {
    border-bottom: none;
    margin-top: 30px;
    border-left: 1px solid #e6a23c;
    .value {
      margin-left: 5px;
      flex: 1;
      height: 40px;
      display: flex;
      align-items: center;
      border-right: 1px solid #e6a23c;
    }
  }
  &.d-flex-first {
    display: flex;
    align-items: flex-start;
    .column-left {
      width: 40%;
      height: 41px;
      display: flex;
      align-items: center;
      background: #fee7c5;
      .flex-item {
        width: 40%;
        height: 41px;
        display: flex;
        align-items: center;

        &:nth-child(1) {
          border-right: 1px solid #e6a23c;
        }
        border-bottom: 1px solid #e6a23c;
      }
    }
  }
  .flex-item {
    width: 33.33%;
    box-sizing: border-box;
    display: flex;
    height: 40px;
    text-align: left;
    border-bottom: 1px solid #e6a23c;
    overflow: hidden;

    .label {
      padding-left: 5px;
      min-width: 120px;
      height: 40px;
      display: flex;
      align-items: center;
      text-align: left;

      border-right: 1px solid #e6a23c;
      background: #fee7c5;
    }

    &:nth-child(4n-3) {
      padding-left: 0;
    }
  }
}
.button-search {
  background-color: #e6a23c;
  border: 0px #e6a23c;
  color: #ffff;
  margin: 0 auto;
  margin-top: 20px;
  display: block;
}
.content_title {
  margin: 10px auto 0;
  // width: 90%;
  text-align: left;
  &.content_column {
    width: 99%;
    margin-top: 40px;
    font-size: 14px;

    .colums {
      flex: 1;
    }
    .label-column {
      align-items: center;
      border-bottom: 1px solid #e6a23c;
      span {
        padding-left: 15px;
      }
      .addColumn {
        width: 50px;
        height: 40px;
        font-size: 18px;
        background: #fee7c5;
      }
      .label {
        flex: 1;
        height: 40px;
        line-height: 40px;

        border-left: 1px solid #e6a23c;
        background: #fee7c5;
      }
    }
  }
  .select-wrap {
    border-left: 1px solid #e6a23c;
  }
  .input-filter,
  .item {
    border-right: 1px solid #e6a23c;
    border-bottom: 1px solid #e6a23c;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    height: 40px;
    flex: 1;
    overflow: hidden;
    span {
      padding-left: 15px;
    }
    &.input-special-filter {
      background: #f5f7fa;
      text-align: left;
      line-height: 40px;
      color: #c0c4cc;
      // border-left: 1px solid #e6a23c;
    }
    &:nth-child(6n) {
      border-right: none;
    }
  }
}
.clearfix:after {
  content: "";
  height: 0;
  line-height: 0;
  display: block;
  visibility: hidden;
  clear: both;
}
.clearfix {
  zoom: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/CRSupplementList.vue